import { render, staticRenderFns } from "./product-details-general.vue?vue&type=template&id=34f1069c&scoped=true&"
import script from "./product-details-general.vue?vue&type=script&lang=js&"
export * from "./product-details-general.vue?vue&type=script&lang=js&"
import style0 from "./product-details-general.vue?vue&type=style&index=0&id=34f1069c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f1069c",
  null
  
)

export default component.exports